const homepageData = {
  name: 'Hello I am Tram Nguyen',
  title: ' and a Front End Developer',
  subtitle:
    'I am excited to take my passion to the next level and pursue a career in frontend development, where I can create aesthetic and user-friendly applications.',
};

export default homepageData;
